import { ButtonGroup, Fieldset, Form, Layout } from '@vwfs-bronson/bronson-react';
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { journeyDataActions, journeyDataSelectors } from '../../services/redux/features/journeyData.slice';
import { VehicleType } from '../../types/vehicleTypeSelect';

interface ButtonModel {
  iconName: string;
  value: VehicleType;
  translateKey: string;
}
const buttons: Array<ButtonModel> = [
  {
    iconName: 'semantic-car-value',
    value: 'newBto',
    translateKey: 'vehicleTypeSelectPage:vehicleTypeSelector.buttons.newCarBto',
  },
  // {
  //   iconName: 'cars-right-left',
  //   value: CarType.newStock,
  //   translateKey: 'vehicleTypeSelectPage:vehicleTypeSelector.buttons.newCarStock',
  // },
  {
    iconName: 'semantic-car',
    value: 'used',
    translateKey: 'vehicleTypeSelectPage:vehicleTypeSelector.buttons.usedCar',
  },
];

export const VehicleTypeSelectForm: FunctionComponent = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const vehicleType = useSelector(journeyDataSelectors.vehicleType);

  return (
    <Form>
      <Fieldset.Row>
        <Layout className="u-m-none">
          <Layout.Item default="1/1">
            <ButtonGroup buttonGroupName="vehicle-select" buttonGroupType="radio">
              {buttons.map((button: ButtonModel, i: number) => (
                <ButtonGroup.Item
                  index={`vehicleTypeSelection_ ${i.toString()}`}
                  readOnly
                  key={`${button.value}_key`}
                  testId={`button_${button.value}`}
                  buttonGroupItemIcon={button.iconName}
                  checked={vehicleType === button.value}
                  onClick={() => {
                    dispatch(journeyDataActions.setVehicleType(button.value));
                  }}
                >
                  {t(button.translateKey)}
                </ButtonGroup.Item>
              ))}
            </ButtonGroup>
          </Layout.Item>
        </Layout>
      </Fieldset.Row>
    </Form>
  );
};
